<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLoading" persistent max-width="300">
      <v-card>
        <v-card-title>Carregando relatório...</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ errorMessage }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo do Gráfico Radar -->
    <v-dialog v-model="showChartDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline d-flex align-center">
          <span>{{ chartTitle }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <!-- Botões de seleção do tipo de dados -->
          <div class="mb-4 d-flex justify-center">
            <v-btn-group class="chart-button-group chart-data-buttons">
              <v-btn
                small
                class="chart-option-button"
                :color="
                  selectedChartType === 'vendas' ? '#18d647' : 'secondary'
                "
                @click="selectChartType('vendas')"
              >
                <v-icon left>mdi-cart</v-icon>
                Vendas
              </v-btn>
              <v-btn
                small
                class="chart-option-button"
                :color="
                  selectedChartType === 'cancelados' ? '#18d647' : 'secondary'
                "
                @click="selectChartType('cancelados')"
              >
                <v-icon left>mdi-cancel</v-icon>
                Cancelados
              </v-btn>
              <v-btn
                small
                class="chart-option-button"
                :color="
                  selectedChartType === 'ativos' ? '#18d647' : 'secondary'
                "
                @click="selectChartType('ativos')"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Ativos
              </v-btn>
            </v-btn-group>
          </div>

          <!-- Gráfico -->
          <div style="height: 400px">
            <apexcharts
              v-if="chartData.length > 0"
              :type="selectedGraphType"
              height="350"
              :options="chartOptions"
              :series="chartData"
            ></apexcharts>
          </div>

          <!-- Botões para alternar tipo de gráfico -->
          <div class="mt-3 d-flex justify-center">
            <v-btn-group class="chart-button-group chart-type-buttons">
              <v-btn
                small
                class="chart-option-button"
                :color="selectedGraphType === 'radar' ? '#18d647' : 'secondary'"
                @click="selectGraphType('radar')"
              >
                <v-icon left>mdi-radar</v-icon>
                Radar
              </v-btn>
              <v-btn
                small
                class="chart-option-button"
                :color="selectedGraphType === 'bar' ? '#18d647' : 'secondary'"
                @click="selectGraphType('bar')"
              >
                <v-icon left>mdi-chart-bar</v-icon>
                Barras
              </v-btn>
            </v-btn-group>
          </div>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="showChartDialog = false">
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-col cols="12">
        <filtro-component
          @filtrar="filterData"
          @showError="handleFilterError"
        ></filtro-component>
      </v-col>
    </v-container>

    <v-row class="px-4">
      <v-col cols="12" sm="6" class="dashboard-card-column">
        <base-material-stats-card
          v-if="!card1_loading"
          color="green"
          icon="mdi-file-document-check-outline"
          title="Total de Vendas"
          sub-icon-color="blue"
          :valuex="false"
          :value="cards.vendas"
          :sub-text="'Total Ativos: ' + cards.ativas"
        />
        <CardLoadComponent v-if="card1_loading" />
      </v-col>

      <v-col cols="12" sm="6" class="dashboard-card-column">
        <base-material-stats-card
          v-if="!card2_loading"
          color="red"
          icon="mdi-cancel"
          title="Total Cancelados"
          sub-icon-color="white"
          :value="cards.canceladas"
          :valuex="false"
          :sub-text="
            'Tempo médio Cancelamento (dias): ' + cards.tempoMedioCancelamento
          "
        />
        <CardLoadComponent v-if="card2_loading" />
      </v-col>

      <v-col cols="12" sm="6" class="dashboard-card-column">
        <base-material-stats-card
          v-if="!card3_loading"
          color="orange"
          icon="mdi-alert-circle"
          title="Motivo mais frequente"
          sub-icon-color="red"
          :valuex="false"
          :value="formatCancellationReason(
            cards.motivoMaisComum,
            cards.qtdMotivoMaisComum
          )"
          :value-title="formatCancellationReasonTitle(
            cards.motivoMaisComum,
            cards.qtdMotivoMaisComum
          )"
          :sub-text="'Idade Média: ' + cards.idadeMediaCancelados"
        />
        <CardLoadComponent v-if="card3_loading" />
      </v-col>

      <v-col cols="12" sm="6" class="dashboard-card-column">
        <base-material-stats-card
          v-if="!card4_loading"
          color="blue"
          icon="mdi-account-heart-outline"
          title="Contratos com serviço"
          sub-icon-color="red"
          :valuex="false"
          :value="cards.totalContratosComServico"
          :sub-text="
            'Cancelados com serviço: ' + cards.totalCanceladosComServico
          "
        />
        <CardLoadComponent v-if="card4_loading" />
      </v-col>
      <v-col cols="12" sm="6" class="dashboard-card-column">
        <base-material-stats-card
          v-if="!card4_loading"
          color="purple"
          icon="mdi-alert"
          title="Contratos inadimplentes"
          sub-icon-color="orange"
          :valuex="false"
          :value="cards.totalContratosInadimplentes"
          :sub-text="
            'Contratos com acordos: ' + cards.totalContratosComAcordo
          "
        />
        <CardLoadComponent v-if="card4_loading" />
      </v-col>
    </v-row>

    <v-container
      style="background-color: #eee"
      id="contrato"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-cart-arrow-up"
            title="Retenção de Vendas"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-card class="px-4 py-4">
              <v-card-title class="titulo-retencao d-flex align-center">
                Retenção após 3 meses
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="primary"
                  class="chart-report-button"
                  title="Visualizar gráfico de retenção após 3 meses"
                  aria-label="Visualizar gráfico de retenção após 3 meses"
                  @click="openChartDialog('3', Vendas3meses)"
                  :disabled="Vendas3meses.length === 0"
                >
                  <v-icon left small>mdi-chart-line</v-icon>
                  Ver gráfico
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  style="margin-top: 1rem; min-height: 30vh"
                  :headers="headers"
                  :items="Vendas3meses"
                  :items-per-page="50"
                  items-per-page-text="Linhas por página"
                  class="elevation-0 text-center"
                  :sort-by="['periodo']"
                  :sort-desc="[false]"
                >
                  <template v-slot:top>
                    <v-progress-linear
                      v-if="isLoading3"
                      indeterminate
                      color="rgb(71 130 180)"
                    ></v-progress-linear>
                  </template>

                  <template v-slot:item="row">
                    <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                      <td class="linha" style="font-size: 12px">
                        {{ row.item.periodo }}
                      </td>
                      <td class="linha">
                        {{ row.item.vendas }}
                      </td>

                      <td class="linha">
                        {{ row.item.cancelados }}
                      </td>
                      <td class="linha">
                        {{ row.item.emDia }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso1p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso2p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso3p }}
                      </td>
                      <td class="linha">
                        {{ calculateAtraso4Mais(row.item) }}
                      </td>
                      <td class="linha">
                        {{ row.item.totalInad }}
                      </td>
                      <td class="linha">{{ row.item.pctIndad }}%</td>
                      <td class="linha">{{ row.item.pctAtivos }}%</td>
                      <td>
                        <div
                          @click="download_xls(row.item.periodo, 3)"
                          title="Fazer Download do Arquivo"
                          style="
                            color: green;
                            font-size: 20px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                          "
                        >
                          <i class="fas fa-file-excel"></i>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append>
                    <tr v-if="Vendas3meses.length" class="total-row">
                      <td class="linha">Total</td>
                      <td
                        v-for="column in totalColumns"
                        :key="column"
                        class="linha"
                      >
                        {{ formatTotal(calculateColumnTotal(Vendas3meses, column))
                        }}{{ isPercentageColumn(column) ? "%" : "" }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="px-4 py-4">
              <v-card-title class="titulo-retencao d-flex align-center">
                Retenção após 6 meses
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="primary"
                  class="chart-report-button"
                  title="Visualizar gráfico de retenção após 6 meses"
                  aria-label="Visualizar gráfico de retenção após 6 meses"
                  @click="openChartDialog('6', Vendas6meses)"
                  :disabled="Vendas6meses.length === 0"
                >
                  <v-icon left small>mdi-chart-line</v-icon>
                  Ver gráfico
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  style="margin-top: 1rem; min-height: 30vh"
                  :headers="headers"
                  :items="Vendas6meses"
                  :items-per-page="50"
                  items-per-page-text="Linhas por página"
                  class="elevation-0 text-center"
                  :sort-by="['periodo']"
                  :sort-desc="[false]"
                >
                  <template v-slot:top>
                    <v-progress-linear
                      v-if="isLoading6"
                      indeterminate
                      color="rgb(71 130 180)"
                    ></v-progress-linear>
                  </template>

                  <template v-slot:item="row">
                    <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                      <td class="linha" style="font-size: 12px">
                        {{ row.item.periodo }}
                      </td>
                      <td class="linha">
                        {{ row.item.vendas }}
                      </td>

                      <td class="linha">
                        {{ row.item.cancelados }}
                      </td>
                      <td class="linha">
                        {{ row.item.emDia }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso1p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso2p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso3p }}
                      </td>
                      <td class="linha">
                        {{ calculateAtraso4Mais(row.item) }}
                      </td>
                      <td class="linha">
                        {{ row.item.totalInad }}
                      </td>
                      <td class="linha">{{ row.item.pctIndad }}%</td>
                      <td class="linha">{{ row.item.pctAtivos }}%</td>
                      <td>
                        <div
                          @click="download_xls(row.item.periodo, 6)"
                          title="Fazer Download do Arquivo"
                          style="
                            color: green;
                            font-size: 20px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                          "
                        >
                          <i class="fas fa-file-excel"></i>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append>
                    <tr v-if="Vendas6meses.length" class="total-row">
                      <td class="linha">Total</td>
                      <td
                        v-for="column in totalColumns"
                        :key="column"
                        class="linha"
                      >
                        {{ formatTotal(calculateColumnTotal(Vendas6meses, column))
                        }}{{ isPercentageColumn(column) ? "%" : "" }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="px-4 py-4">
              <v-card-title class="titulo-retencao d-flex align-center">
                Retenção após 12 meses
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="primary"
                  class="chart-report-button"
                  title="Visualizar gráfico de retenção após 12 meses"
                  aria-label="Visualizar gráfico de retenção após 12 meses"
                  @click="openChartDialog('12', Vendas12meses)"
                  :disabled="Vendas12meses.length === 0"
                >
                  <v-icon left small>mdi-chart-line</v-icon>
                  Ver gráfico
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  style="margin-top: 1rem; min-height: 30vh"
                  :headers="headers"
                  :items="Vendas12meses"
                  :items-per-page="50"
                  items-per-page-text="Linhas por página"
                  class="elevation-0 text-center"
                  :sort-by="['periodo']"
                  :sort-desc="[false]"
                >
                  <template v-slot:top>
                    <v-progress-linear
                      v-if="isLoading12"
                      indeterminate
                      color="rgb(71 130 180)"
                    ></v-progress-linear>
                  </template>

                  <template v-slot:item="row">
                    <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                      <td class="linha" style="font-size: 12px">
                        {{ row.item.periodo }}
                      </td>
                      <td class="linha">
                        {{ row.item.vendas }}
                      </td>

                      <td class="linha">
                        {{ row.item.cancelados }}
                      </td>
                      <td class="linha">
                        {{ row.item.emDia }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso1p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso2p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso3p }}
                      </td>
                      <td class="linha">
                        {{ calculateAtraso4Mais(row.item) }}
                      </td>
                      <td class="linha">
                        {{ row.item.totalInad }}
                      </td>
                      <td class="linha">{{ row.item.pctIndad }}%</td>
                      <td class="linha">{{ row.item.pctAtivos }}%</td>
                      <td>
                        <div
                          title="Fazer Download do Arquivo"
                          @click="download_xls(row.item.periodo, 12)"
                          style="
                            color: green;
                            font-size: 20px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                          "
                        >
                          <i class="fas fa-file-excel"></i>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append>
                    <tr v-if="Vendas12meses.length" class="total-row">
                      <td class="linha">Total</td>
                      <td
                        v-for="column in totalColumns"
                        :key="column"
                        class="linha"
                      >
                        {{ formatTotal(calculateColumnTotal(Vendas12meses, column))
                        }}{{ isPercentageColumn(column) ? "%" : "" }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="px-4 py-4">
              <v-card-title class="titulo-retencao d-flex align-center">
                Retenção após 24 meses
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="primary"
                  class="chart-report-button"
                  title="Visualizar gráfico de retenção após 24 meses"
                  aria-label="Visualizar gráfico de retenção após 24 meses"
                  @click="openChartDialog('24', Vendas24meses)"
                  :disabled="Vendas24meses.length === 0"
                >
                  <v-icon left small>mdi-chart-line</v-icon>
                  Ver gráfico
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  style="margin-top: 1rem; min-height: 30vh"
                  :headers="headers"
                  :items="Vendas24meses"
                  :items-per-page="50"
                  items-per-page-text="Linhas por página"
                  class="elevation-0 text-center"
                  :sort-by="['periodo']"
                  :sort-desc="[false]"
                >
                  <template v-slot:top>
                    <v-progress-linear
                      v-if="isLoading24"
                      indeterminate
                      color="rgb(71 130 180)"
                    ></v-progress-linear>
                  </template>

                  <template v-slot:item="row">
                    <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                      <td class="linha" style="font-size: 12px">
                        {{ row.item.periodo }}
                      </td>
                      <td class="linha">
                        {{ row.item.vendas }}
                      </td>

                      <td class="linha">
                        {{ row.item.cancelados }}
                      </td>
                      <td class="linha">
                        {{ row.item.emDia }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso1p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso2p }}
                      </td>
                      <td class="linha">
                        {{ row.item.atraso3p }}
                      </td>
                      <td class="linha">
                        {{ calculateAtraso4Mais(row.item) }}
                      </td>
                      <td class="linha">
                        {{ row.item.totalInad }}
                      </td>
                      <td class="linha">{{ row.item.pctIndad }}%</td>
                      <td class="linha">{{ row.item.pctAtivos }}%</td>
                      <td>
                        <div
                          title="Fazer Download do Arquivo"
                          @click="download_xls(row.item.periodo, 24)"
                          style="
                            color: green;
                            font-size: 20px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                          "
                        >
                          <i class="fas fa-file-excel"></i>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append>
                    <tr v-if="Vendas24meses.length" class="total-row">
                      <td class="linha">Total</td>
                      <td
                        v-for="column in totalColumns"
                        :key="column"
                        class="linha"
                      >
                        {{ formatTotal(calculateColumnTotal(Vendas24meses, column))
                        }}{{ isPercentageColumn(column) ? "%" : "" }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </base-material-card>
          <br />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import FiltroComponent from "./components/FiltroRetencao.vue";
import Financeiro from "../../services/financeiro";
import CardLoadComponent from "./components/CardLoad.vue";
import downloadBlob from "../../services/downloadBlob";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "Cobranca",

  components: {
    FiltroComponent,
    CardLoadComponent,
    apexcharts: VueApexCharts,
  },

  data() {
    return {
      card1_loading: false,
      card2_loading: false,
      card3_loading: false,
      card4_loading: false,
      Vendas3meses: [],
      Vendas6meses: [],
      Vendas12meses: [],
      Vendas24meses: [],
      headers: [
        { text: "Mês", value: "periodo", align: "center" },
        { text: "Vendas", value: "vendas", align: "center" },
        { text: "Cancelados", value: "cancelados", align: "left" },
        { text: "Em dia", value: "emDia", align: "center" },
        { text: "Atraso 1p", value: "atraso1p", align: "center" },
        { text: "Atraso 2p", value: "atraso2p", align: "center" },
        { text: "Atraso 3p", value: "atraso3p", align: "center" },
        {
          text: "Atraso 4+",
          value: "atraso4Mais",
          align: "center",
          sortable: false,
        },
        { text: "Total Inadimplentes", value: "totalInad", align: "center" },
        { text: "Inadimplentes", value: "pctIndad", align: "center" },
        { text: "Retenção", value: "pctAtivos", align: "center" },
        { text: "", value: "", sortable: false, align: "center" },
      ],
      totalColumns: [
        "vendas",
        "cancelados",
        "emDia",
        "atraso1p",
        "atraso2p",
        "atraso3p",
        "atraso4Mais",
        "totalInad",
        "pctIndad",
        "pctAtivos",
      ],
      search: "",
      selectedCompany: "",
      initialCompetence: "",
      finalCompetence: "",
      selectedSaleTypes: [],
      selectedSellerIds: [],

      showFilter: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
      ],
      showProgress: false,
      showLoading: false,
      showError: false,
      errorMessage: "Por favor, verifique os filtros informados.",
      isLoading3: false,
      isLoading6: false,
      isLoading12: false,
      isLoading24: false,
      // Variáveis para o diálogo do gráfico
      showChartDialog: false,
      chartTitle: "",
      chartData: [],
      chartDataSource: [], // Dados originais para alternar entre tipos
      selectedChartType: "ativos", // Tipo selecionado: 'vendas', 'cancelados', 'ativos'
      selectedGraphType: "radar", // Tipo de gráfico: 'radar', 'bar'
      chartOptions: {
        chart: {
          type: "radar",
          height: 350,
        },
        title: {
          text: "Retenção de Vendas",
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          show: false,
        },
        plotOptions: {
          radar: {
            size: 140,
            polygons: {
              strokeColors: "#e9e9e9",
              fill: {
                colors: ["#f8f8f8", "#fff"],
              },
            },
          },
        },
        colors: ["#FF4560"],
        markers: {
          size: 4,
          colors: ["#fff"],
          strokeColor: "#FF4560",
          strokeWidth: 2,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 0.1,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["#FF4560"],
          dashArray: 0,
        },
      },
      cards: {
        vendas: 0,
        ativas: 0,
        canceladas: 0,
        tempoMedioCancelamento: 0,
        motivoMaisComum: "",
        qtdMotivoMaisComum: 0,
        idadeMediaCancelados: 0,
        totalContratosComServico: 0,
        totalCanceladosComServico: 0,
        totalContratosInadimplentes: 0,
        totalContratosComAcordo: 0,
      },
    };
  },
  // mounted() {
  //   const initialFilter = {
  //     selectedCompany: "PREVIDA",
  //     initialCompetence: `${new Date().getFullYear()}-01`,
  //     finalCompetence: new Date().toISOString().slice(0, 7),
  //   };
  //   this.filterData(initialFilter);
  // },
  methods: {
    formatCancellationReasonTitle(reason, quantity) {
      const text = reason || "";
      return `${text ? text + " - " : ""}${quantity || 0}`;
    },

    formatCancellationReason(reason, quantity) {
      const text = reason || "";
      const maxLength = 14;

      if (text.length <= maxLength) {
        return `${text ? text + " - " : ""}${quantity || 0}`;
      }

      const visibleLength = maxLength - 1;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedReason = `${text.slice(0, startLength)}…${text.slice(
        -endLength
      )}`;

      return `${truncatedReason} - ${quantity || 0}`;
    },

    handleFilterError(message) {
      this.errorMessage = message || "Por favor, verifique os filtros informados.";
      this.showError = true;
    },

    sumColumn(items, column) {
      return items.reduce((total, item) => {
        const value = Number(String(item[column] || 0).replace(",", "."));
        return total + (Number.isFinite(value) ? value : 0);
      }, 0);
    },

    calculateAtraso4Mais(item) {
      return ["atraso4p", "atraso5p", "atraso6p"].reduce(
        (total, column) => {
          const value = Number(String(item[column] || 0).replace(",", "."));
          return total + (Number.isFinite(value) ? value : 0);
        },
        0
      );
    },

    calculateColumnTotal(items, column) {
      if (column === "atraso4Mais") {
        return items.reduce(
          (total, item) => total + this.calculateAtraso4Mais(item),
          0
        );
      }

      if (column === "pctIndad") {
        const totalAtivos = this.sumColumn(items, "ativos");
        const totalInadimplentes = this.sumColumn(items, "totalInad");

        return totalAtivos > 0
          ? Math.round((totalInadimplentes * 100) / totalAtivos)
          : 0;
      }

      if (column === "pctAtivos") {
        const totalVendas = this.sumColumn(items, "vendas");
        const totalAtivos = this.sumColumn(items, "ativos");

        return totalVendas > 0
          ? Math.round((totalAtivos * 100) / totalVendas)
          : 0;
      }

      return this.sumColumn(items, column);
    },

    formatTotal(value) {
      return value.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      });
    },

    isPercentageColumn(column) {
      return column === "pctIndad" || column === "pctAtivos";
    },

    filterData(filterPayload) {
      if (!filterPayload) return;
      const {
        selectedCompany,
        initialCompetence,
        finalCompetence,
        selectedSaleTypes = [],
        selectedSellerIds = [],
      } = filterPayload;
      if (!selectedCompany || !initialCompetence || !finalCompetence) return;
      this.selectedCompany = selectedCompany;
      this.initialCompetence = initialCompetence;
      this.finalCompetence = finalCompetence;
      this.selectedSaleTypes = selectedSaleTypes;
      this.selectedSellerIds = selectedSellerIds;
      this.consultarVendas(
        selectedCompany,
        initialCompetence,
        finalCompetence,
        selectedSaleTypes,
        selectedSellerIds
      );
    },
    async consultarVendas(
      empresa,
      initialCompetence,
      finalCompetence,
      saleTypes,
      sellerIds
    ) {
      this.showLoading = true;
      this.isLoading3 = true;
      this.isLoading6 = true;
      this.isLoading12 = true;
      this.isLoading24 = true;
      this.card1_loading = true;
      this.card2_loading = true;
      this.card3_loading = true;
      this.card4_loading = true;
      const initialDate = `${initialCompetence}-01`;
      const finalDate = `${finalCompetence}-01`;

      const cardsRequest = Financeiro.listaCardsRetencao(
        initialDate,
        finalDate,
        empresa,
        saleTypes,
        sellerIds
      )
        .then((response) => {
          this.cards = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        })
        .finally(() => {
          this.card1_loading = false;
          this.card2_loading = false;
          this.card3_loading = false;
          this.card4_loading = false;
        });

      const vendas3Request = Financeiro.vendasRetencao(
        initialDate,
        finalDate,
        empresa,
        3,
        saleTypes,
        sellerIds
      )
        .then((response) => {
          this.Vendas3meses = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        })
        .finally(() => (this.isLoading3 = false));

      const vendas6Request = Financeiro.vendasRetencao(
        initialDate,
        finalDate,
        empresa,
        6,
        saleTypes,
        sellerIds
      )
        .then((response) => {
          this.Vendas6meses = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        })
        .finally(() => (this.isLoading6 = false));

      const vendas12Request = Financeiro.vendasRetencao(
        initialDate,
        finalDate,
        empresa,
        12,
        saleTypes,
        sellerIds
      )
        .then((response) => {
          this.Vendas12meses = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        })
        .finally(() => (this.isLoading12 = false));

      const vendas24Request = Financeiro.vendasRetencao(
        initialDate,
        finalDate,
        empresa,
        24,
        saleTypes,
        sellerIds
      )
        .then((response) => {
          this.Vendas24meses = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados:", error);
        })
        .finally(() => (this.isLoading24 = false));

      try {
        await Promise.all([
          cardsRequest,
          vendas3Request,
          vendas6Request,
          vendas12Request,
          vendas24Request,
        ]);
      } finally {
        this.showLoading = false;
      }
    },
    download_xls(periodo, periodicidade) {
      this.showProgress = true;

      const [mes, ano] = periodo.split("/");
      const primeiroDiaMes = `${ano}-${mes}-01`;

      Financeiro.listaVendasRetencao(
        primeiroDiaMes,
        this.selectedCompany,
        periodicidade,
        this.selectedSaleTypes,
        this.selectedSellerIds
      )
        .then((response) => {
          const fileName = `retencaodevendas_${mes + ano}_${Date.now()}.xlsx`;
          downloadBlob(new Blob([response.data]), fileName);
        })
        .catch(() => alert("Erro ao baixar arquivo Excel"))
        .finally(() => (this.showProgress = false));
    },

    openChartDialog(periodo, dados) {
      // Definir o título baseado no período
      const periodoMap = {
        3: "3 meses",
        6: "6 meses",
        12: "12 meses",
        24: "24 meses",
      };

      this.chartTitle = `Retenção após ${periodoMap[periodo]}`;

      // Armazenar dados originais para alternar entre tipos
      this.chartDataSource = dados;

      // Atualizar título do gráfico
      this.chartOptions = {
        ...this.chartOptions,
        title: {
          text: this.chartTitle,
        },
      };

      // Resetar para 'ativos' e 'radar' e atualizar dados
      this.selectedChartType = "ativos";
      this.selectedGraphType = "radar";
      this.updateChartData();

      // Abrir o diálogo
      this.showChartDialog = true;
    },

    selectChartType(type) {
      this.selectedChartType = type;
      this.updateChartData();
    },

    selectGraphType(type) {
      this.selectedGraphType = type;
      this.updateChartData();
    },

    updateChartData() {
      if (!this.chartDataSource || this.chartDataSource.length === 0) return;

      // Ordenar dados por período (MM/YYYY)
      const sortedData = [...this.chartDataSource].sort((a, b) => {
        // Converter MM/YYYY para YYYY-MM para comparação
        const [mesA, anoA] = a.periodo.split("/");
        const [mesB, anoB] = b.periodo.split("/");
        const dataA = `${anoA}-${mesA.padStart(2, "0")}`;
        const dataB = `${anoB}-${mesB.padStart(2, "0")}`;
        return dataA.localeCompare(dataB);
      });

      // Mapear tipos para nomes e cores
      const typeConfig = {
        vendas: { name: "Vendas", color: "#00E396" },
        cancelados: { name: "Cancelados", color: "#FF4560" },
        ativos: { name: "Ativos", color: "#008FFB" },
      };

      const config = typeConfig[this.selectedChartType];
      const categories = sortedData.map((item) => item.periodo);
      const data = sortedData.map((item) => item[this.selectedChartType]);

      // Configurações específicas por tipo de gráfico
      let chartSpecificOptions = {};

      if (this.selectedGraphType === "radar") {
        chartSpecificOptions = {
          chart: {
            type: "radar",
            height: 350,
          },
          plotOptions: {
            radar: {
              size: 140,
              polygons: {
                strokeColors: "#e9e9e9",
                fill: {
                  colors: ["#f8f8f8", "#fff"],
                },
              },
            },
          },
          markers: {
            size: 4,
            colors: ["#fff"],
            strokeColor: config.color,
            strokeWidth: 2,
          },
          fill: {
            opacity: 0.1,
          },
          stroke: {
            show: true,
            width: 2,
            colors: [config.color],
            dashArray: 0,
          },
        };
      } else if (this.selectedGraphType === "bar") {
        chartSpecificOptions = {
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          fill: {
            opacity: 0.9,
          },
        };
      }

      // Atualizar opções do gráfico com categorias ordenadas
      this.chartOptions = {
        ...this.chartOptions,
        ...chartSpecificOptions,
        colors: [config.color],
        xaxis: {
          categories: categories,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
        tooltip: {
          y: {
            formatter: function (val, opts) {
              const seriesName =
                opts.series[opts.seriesIndex][opts.dataPointIndex];
              return val + " (" + categories[opts.dataPointIndex] + ")";
            },
          },
        },
      };

      // Preparar dados da série
      this.chartData = [
        {
          name: config.name,
          data: data,
        },
      ];
    },

    dashboard() {},
  },
};
</script>

<style scoped>
.dashboard-card-column {
  display: flex;
}

.dashboard-card-column > * {
  width: 100%;
}

@media (min-width: 1264px) {
  .dashboard-card-column {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

.linha {
  font-size: 13px !important;
  font-weight: bold !important;
}

::v-deep .v-data-table thead th {
  font-size: 13px !important;
  font-weight: 700 !important;
}

.cor-row {
  background-color: #90d34c21;
  transition: none !important;
}

.total-row {
  background-color: #e8f5e9;
  color: #263238;
  font-size: 12px;
  font-weight: 700;
}

.total-row td {
  border-top: 2px solid #66bb6a !important;
}

.titulo-retencao {
  font-size: 0.8rem;
  font-weight: bold;
  color: #343f53;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 16px;
  text-align: center;
}

.chart-report-button {
  flex-shrink: 0;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
}

.chart-button-group {
  display: flex;
  max-width: 100%;
}

.chart-data-buttons {
  width: 450px;
}

.chart-type-buttons {
  width: 300px;
}

.chart-option-button {
  flex: 1 1 0 !important;
  width: 0;
  min-width: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}

@media (max-width: 480px) {
  .titulo-retencao {
    flex-wrap: wrap;
    gap: 12px;
  }

  .titulo-retencao .v-spacer {
    display: none;
  }

  .chart-report-button {
    width: 100%;
  }

  .chart-option-button {
    padding: 0 8px !important;
  }
}

.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 80px;
}
</style>
